import { render } from "./v-icon-button.vue?vue&type=template&id=37709784&scoped=true"
import script from "./v-icon-button.vue?vue&type=script&lang=js"
export * from "./v-icon-button.vue?vue&type=script&lang=js"

import "./v-icon-button.vue?vue&type=style&index=0&id=37709784&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37709784"]])

export default __exports__